import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { permitQuickPrompts } from '../../data/permis';
import { PromptBox } from '../demandes/PromptBox';
interface PermisComposerProps {
  layoutId: string;
  /** Vrai quand le dialogue est ouvert : la pilule laisse sa place au panneau. */
  morphing: boolean;
  onOpen: (text: string) => void;
}
export function PermisComposer({
  layoutId,
  morphing,
  onOpen
}: PermisComposerProps) {
  const [draft, setDraft] = useState('');
  const open = (value: string) => {
    const text = value.trim();
    if (!text) return;
    onOpen(text);
    setDraft('');
  };
  return <section aria-labelledby="permis-atna-titre" data-id="element-2403" data-mp="12edd96uk45mv">
      <h2 id="permis-atna-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy sm:text-3xl" data-id="element-2404" data-mp="12dloaevgt65k">
        Quel projet voulez-vous réaliser ?
      </h2>
      <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-2405" data-mp="1u51cuegl12yf">
        Décrivez vos travaux. ATNA détermine le permis requis, les règles à respecter et prépare votre demande.
      </p>

      <div className="mt-6" data-id="element-2406" data-mp="24458k21u1ymj">
        {morphing ?
      // Placeholder keeps the page from jumping while the pill morphs into the dialog.
      <div className="h-[66px]" aria-hidden="true" data-id="element-2407" data-mp="2dt6ndown69yx" /> : <motion.div layoutId={layoutId} style={{
        borderRadius: 999
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-2408" data-mp="2duhpzlecpbog">
            <PromptBox value={draft} onChange={setDraft} onSubmit={() => open(draft)} variant="hero" placeholder="Ex. « je veux construire une piscine »" data-id="element-2409" data-mp="2msjy0kwi54l8" />
          </motion.div>}
      </div>

      <ul className="-mx-5 mt-4 flex snap-x gap-2.5 overflow-x-auto px-5 pb-1 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0" data-id="element-2410" data-mp="2rsoisn4g0lh9">
        {permitQuickPrompts.map(quick => <li key={quick} className="shrink-0 snap-start" data-id="element-2411" data-mp="xf6pejhcwueb">
            <button type="button" onClick={() => open(quick)} className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2412" data-mp="xgrlidjbklea">
              {quick}
            </button>
          </li>)}
      </ul>
    </section>;
}